import {
	capitalize,
	isBigCard,
	isHighlightedBlack,
	isHighlightedGold,
	isHighlightedInfinite,
	isHighlightedSilver,
	isProject,
	isProjectProperty,
	showBathrooms,
	showBedrooms,
	showGuests,
	showM2,
	showRooms,
} from "@Utils/Functions";
import {
	CardImageGallery,
	DataImages,
} from "../../Components/Property/PropertyCard/CardImageGallery/web";
import { useEffect, useRef, useState } from "react";
import { OwnerLogo } from "shared-components/Components/Property/OwnerLogo/web";
import { useContext } from "react";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import "./ListingCard.less";

import dynamic from "next/dynamic";
import { Favorite } from "shared-components/Components/Property/Favorite/web";
import { TagEvent } from "shared-components/Components/TagEvent/web";
import { FiltersStateContext } from "shared-components/Contexts/Filters/context";
import { HouseIcon } from "shared-components/Components/CustomIcons/HouseIcon";
import { BathroomIcon } from "shared-components/Components/CustomIcons/BathroomIcon";
import PeopleIcon from "shared-components/Components/CustomIcons/PeopleIcon/web";
import { LeadButtons } from "shared-components/Components/Property/InformationRequest/LeadButtons/web";
import { DownArrow } from "shared-components/Components/CustomIcons/DownArrow/web";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { propertyTypes } from "../SearchResults/Sider/TopBarFilters/options";
import { VirtualTourIcon } from "shared-components/Components/CustomIcons/VirtualTourIcon/web";
import { ProjectIcon } from "shared-components/Components/CustomIcons/ProjectIcon/web";
import { BedIcon } from "shared-components/Components/CustomIcons/BedIcon/web";
import { useFilters } from "shared-components/Components/Filters/Filters.hook";
import { CommercialUnit, Currency } from "shared-components";
import {
	firstLetterToUppercase,
	getLocationLabel,
	getProjectCommertialUnitsOrdered,
	getProjectRangePrices,
	getProjectUnitsMinValues,
	htmlToPlainText,
} from "src/utils/Functions";
import { ListingTypeTag } from "shared-components/Components/Property/ListingTypeTag/web";
import { PriceTag } from "shared-components/Components/Property/PriceTag/web";
import { useCardImageGallery } from "shared-components/Components/Property/PropertyCard/CardImageGallery/hook";
import { SquareM2Icon } from "shared-components/Components/CustomIcons/SquareM2Icon/web";
import { HighlightedIconBlack } from "shared-components/Components/CustomIcons/HighlightedIconBlack";
import { HighlightedIconGold } from "shared-components/Components/CustomIcons/HighlightedIconGold";
import { HighlightedIconSilver } from "shared-components/Components/CustomIcons/HighlightedIconSilver";
import { ProductTagIcon } from "shared-components/Components/CustomIcons/ProductTagIcon";
import { FincaClicLogo } from "shared-components/Components/FincaClicLogo/web";
import { FireIcon } from "shared-components/Components/CustomIcons/FireIcon/web";
import M2Icon from "shared-components/Components/CustomIcons/M2Icon";
import Show from "src/Components/Show/web";
import { TierStarIcon } from "shared-components/Components/CustomIcons/TierStarIcon";
import { TierInfiniteIcon } from "shared-components/Components/CustomIcons/TierInfiniteIcon";
import { AsciendeChip } from "shared-components/Components/Property/AsciendeChip/web";
import { useTurboActive } from "shared-components/Components/Property/AsciendeChip/hook";
import { useSerpSignalsV2 } from "shared-components/GlobalHooks/useSerpSignalsV2";

//@ts-ignore
const FacilitiesCard = dynamic(
	() =>
		import("shared-components/Components/Property/FacilitiesCard/web").then(
			mod => mod.FacilitiesCard
		),
	{ ssr: false }
);

type Event = {
	tag: string;
	show: boolean;
	link: string;
	logo: string;
	fecha_inicio_evento: string;
};

type commonExpenses = {
	amount: number;
	hidePrice: boolean;
};

export type ListingData = {
	id?: any;
	legacy_propID?: any;
	isProject?: any;
	singleImage?: boolean;
	img?: any;
	owner?: {
		logo?: any;
		name?: any;
		inmoLink?: any;
		inmoPropsLink?: any;
		inmofull?: any;
		particular?: boolean;
		type?: string;
		has_whatsapp?: boolean;
	};
	fair?: {
		active: boolean;
		detail_text: string;
		listing_text: string;
	};
	images?: DataImages[];
	seller?: any;
	price?: any;
	currency?: Currency;
	currency_id?: any;
	commercial_units?: CommercialUnit[];
	hidePrice?: any;
	highlight?: any;
	property_type_id?: any;
	operation_type_id?: any;
	operation_type?: any;
	bedrooms?: any;
	bathrooms?: any;
	rooms?: any;
	m2?: any;
	guests?: any;
	title?: any;
	description?: any;
	locations?: any;
	facilities?: any;
	link?: any;
	isExternal?: any;
	event?: Event;
	tag?: any;
	turbo_product?: {
		start_date?: string;
		end_date?: string;
		duration?: number;
		start_hour?: string;
	};
	commonExpenses?: commonExpenses;
	commonExpenses_currency?: string;
	project?: any;
	duplicated?: any[];
	temporal_currency?: any;
	temporal_price?: any;
};

type ListingCardProps = {
	preloadImg?: boolean;
	data: ListingData;
	onCancel?: () => void | null;
	hideTags?: boolean;
	hideCta?: boolean;
	staticGallery?: boolean;
	showExpenses?: boolean;
	isFromListing?: boolean;
	showDuplicated?: boolean;
	shortCard?: boolean;
	showFairText?: boolean;
};

// Nombre del badge del tier Infinite. Parametrizado hasta que INF-97 defina el
// nombre definitivo; hoy el nombre de trabajo es "Infinite".
const INFINITE_TIER_LABEL = "Destacado Infinite";

export const ListingCard = ({
	data,
	preloadImg = false,
	showDuplicated = false,
	staticGallery = false,
	isFromListing = false,
	showFairText = true,
	hideTags = false,
	showExpenses = false,
	hideCta = false,
	onCancel,
	shortCard = false, // Se habilita shortCard para mostrar la vista en vertical
}: ListingCardProps) => {
	const { order } = useContext(FiltersStateContext);
	const { country_code, translations, country_name } = useContext(ConfigStateContext);
	const { filters } = useFilters();
	const divRef = useRef(null);
	const screen = useBreakpoint();
	const parentRef = useRef(null);
	const [idealFilters, setIdealFilters] = useState<any>(false);
	const [alreadyShown, setAlreadyShown] = useState(false);
	const [hover, setHover] = useState(false);
	const [duplicatedDropdown, setDuplicatedDropdown] = useState(false);
	const [gallery, setGallery] = useState<DataImages[]>(data.images);
	const isBig = !shortCard && isBigCard(data.highlight, order.value, country_code);
	const signalsV2 = useSerpSignalsV2();
	// Infinite: tier por encima del Black, con banda superior propia (INF-107).
	// Reusa el tratamiento "super highlight" (foto grande, logo, descripción) pero
	// no el layout viejo del Black (nombre del owner arriba) — ver guardas !isInfinite.
	// Va detrás del mismo flag que la ficha (INF-146): el paquete de señales v2 se
	// enciende de una sola vez, y así la banda no puede aparecer suelta en las otras
	// marcas —`main` buildea las cinco— si algún día existiera un highlight 19 fuera de CO.
	const isInfinite = signalsV2 && isHighlightedInfinite(data?.highlight);
	const isSuperHigh = isHighlightedBlack(data?.highlight) || isInfinite;
	// INF-580 — el chip del Asciende ya no distingue por tipo de dueño. Revierte el gate de
	// INF-150 («el bump de un privado es invisible»), cuya premisa cae con INF-451: el bump del
	// privado deja de ser un desempate chiquito debajo del semáforo y pasa a la MISMA super-banda
	// que el del profesional, así que esconderle la insignia lo deja subiendo arriba de los Black
	// sin ninguna señal que lo explique.
	// ⚠️ ORDEN DE DEPLOY: esa unificación vive en search-service detrás de PRIVATE_PLANS_V2, que
	// medido en prod el 2026-08-21 está APAGADO; lo saca INF-582. Si esto sale ANTES, el chip
	// promete un top que el ranking todavía no da — o sea INF-150 al revés.
	const turboActive = useTurboActive(signalsV2 ? data?.turbo_product : undefined);
	// INF-334 (diseño INF-333) — DOS señales juntas: el Asciende no reemplaza al tier, lo
	// acompaña. Deja atrás la regla de INF-196 («una sola señal por aviso, la más alta»), con la
	// que quien pagaba Black + Asciende perdía la insignia de Black. El chip se muestra también
	// con Infinite: ahí el tier lo comunica la banda, no un pill.
	const showAsciende = turboActive;
	// INF-334 — pill del tier Infinite SOLO donde la banda no se dibuja, o sea en el shortCard:
	// así ese aviso deja de quedarse sin ninguna señal. Donde hay banda, jamás pill (es el
	// complemento exacto del gate de la banda, `isInfinite && !shortCard`).
	// OJO: `shortCard` NO es el SERP mobile. `ListingCard` es un solo componente responsive, así
	// que el SERP mobile conserva la banda. Los que pasan `shortCard` son los tres carruseles del
	// home (`HomeProjectsCarouselSection`, `UltimosIngresos/PropertyCard`, `SpecialHomeSlider`) y
	// los similares de la ficha (`PropertySimilars/PropertySimilarsCards`). Ahí es donde hay que
	// mirar este pill.
	const showInfinitePill = isInfinite && shortCard;
	const prices = getProjectRangePrices({ listing: data, filters });
	const isPropertyProject = isProjectProperty(data)
	const isUnitProject = isProject(data)
	const [lowerPriceUnit, setLowerPriceUnit] = useState<CommercialUnit>(data.isProject && data?.commercial_units ? data.commercial_units[0] : ({} as CommercialUnit));
	const propertyType = propertyTypes.filter(type => type.value === data.property_type_id)[0];
	const ids = ["190663135"];
	const ROOMS_PROPERTY_TYPES = [4, 5, 9, 19];

	const onHover = (e?: any) => {
		setHover(true);
	};
	const onHoverEnd = (e?: any) => {
		setHover(false);
	};

	const toggleDuplicatedDropdown = () => {
		setDuplicatedDropdown(!duplicatedDropdown);
		setAlreadyShown(true);
		setTimeout(() => {
			if (duplicatedDropdown) {
				const headerOffset = screen.xs ? 65 : 125; // Altura del header flotante
				const elementPosition = parentRef.current.getBoundingClientRect().top;
				const offsetPosition = elementPosition + window.scrollY - headerOffset;

				window.scrollTo({
					top: offsetPosition,
					behavior: "smooth",
				});
			}
		}, 30);
	};

	// Debe mantenerse en sincronía con la visibilidad de TypologyTag (shared-components/Components/Property/TypologyTag/web.tsx)
	const propertyIsProject = data.isProject;
	const isLot = data.property_type_id === 3;
	const typologyPropertyType =
		propertyIsProject &&
			lowerPriceUnit &&
			lowerPriceUnit.property_type &&
			lowerPriceUnit.property_type?.id
			? lowerPriceUnit.property_type?.id
			: data.property_type_id;
	// en proyectos la card muestra el menor valor entre todas las unidades
	// (ver getProjectUnitsMinValues: bedrooms/rooms según tipo de unidad, lotes excluidos)
	const {
		minBedrooms: minUnitsBedrooms,
		minRooms: minUnitsRooms,
		minBathrooms: minUnitsBathrooms,
		minM2: minUnitsM2,
	} = getProjectUnitsMinValues({ listing: data, country_code });

	const dataBedroom = propertyIsProject ? minUnitsBedrooms : data.bedrooms;
	const dataRooms = propertyIsProject ? minUnitsRooms : data.rooms;
	const dataBathroom = propertyIsProject ? minUnitsBathrooms : data.bathrooms;

	const hideZeroRooms = Number(dataRooms) === 0;
	// los lotes (isLot) no muestran rooms/bedrooms/bathrooms, salvo que sean proyectos
	const shouldShowBedroomsTag = propertyIsProject
		? dataBedroom !== null
		: !isLot &&
		showBedrooms([typologyPropertyType], data.operation_type_id, country_code) &&
		Number(dataBedroom) >= 0;
	// en proyectos rooms solo se muestra si ninguna unidad aporta bedrooms
	const shouldShowRoomsTag = propertyIsProject
		? !shouldShowBedroomsTag && dataRooms !== null
		: !isLot &&
		showRooms([typologyPropertyType], country_code, dataRooms) &&
		!hideZeroRooms &&
		Number(dataRooms) >= 0;
	const shouldShowBathroomsTag = propertyIsProject
		? dataBathroom !== null
		: !isLot &&
		showBathrooms([typologyPropertyType], country_code, dataBathroom) &&
		Number(dataBathroom) > 0;

	const bedrooms = () => {
		if (!shouldShowBedroomsTag) return null;

		return (
			<span className="lc-typologyTag__item body body-2 body-regular medium">
				<span>
					<BedIcon width={20} />

				</span>
				<strong>
					{dataBedroom == 0
						? country_code !== "CO" ? "Mono" : "0 Hab"
						: dataBedroom +
						" " +
						firstLetterToUppercase(translations.hab)
						+ `${dataBedroom > 1 ? 's.' : ''}`}{" "}
				</strong>
			</span>
		);
	};

	const rooms = () => {
		if (!shouldShowRoomsTag) return null;

		return (
			<span className="lc-typologyTag__item body body-2 body-regular medium">
				<span>
					<HouseIcon width={18} />

				</span>
				<strong>
					{dataRooms == 1 ? dataRooms + " Ambiente" : dataRooms + " Ambientes"}{" "}
				</strong>
			</span>
		);
	};

	// En proyectos se prioriza bedrooms; rooms solo si ninguna unidad aporta bedrooms
	const projectRoomsOrBedrooms = () => (shouldShowRoomsTag ? rooms() : bedrooms());

	const bathrooms = () => {
		if (!shouldShowBathroomsTag) return null;

		return (
			<span className="lc-typologyTag__item body body-2 body-regular medium">
				<span>
					<BathroomIcon width={18} />

				</span>
				<strong>
					{dataBathroom} {dataBathroom > 1 ? "Baños" : "Baño"}
				</strong>
			</span>
		);
	};

	const m2 = (propertyType) => {
		const dataM2 = propertyIsProject
			? minUnitsM2 !== null
				? minUnitsM2
				: data.m2
			: data.m2;
		const shouldShowHectares =
			propertyType?.value === 6 &&
			(country_code !== "CO");

		if (showM2(data.operation_type_id) && dataM2 > 0) {
			return (
				<span className="lc-typologyTag__item body body-2 body-regular medium">
					<span>
						<M2Icon width={18} />
					</span>
					<strong>{dataM2} {shouldShowHectares ? 'hectáreas' : 'm²'}</strong>
				</span>
			);
		} else return null;
	};

	useEffect(() => {
		if (!data.isProject && data && "operation_type_id" in data && "property_type_id" in data) {
			setIdealFilters({
				operation_type_id: data.operation_type_id,
				property_type_id: [data.property_type_id],
				maxPrice: data.price + data.price * 0.2,
				bedrooms: [data.bedrooms],
				currencyID: Number(data.currency_id),
			});
		}
	}, []);

	useEffect(() => {
		if (data.id && data.isProject) {
			const unitsOrdered = getProjectCommertialUnitsOrdered({ listing: data });

			if (unitsOrdered && !!unitsOrdered.length) setLowerPriceUnit(unitsOrdered[0]);
		}
	}, [data]);

	const useRooms = ROOMS_PROPERTY_TYPES.includes(data.property_type_id);

	if (!data || !data.id) return null;

	const link = data.project && data.project.id ? data.project.link : data.link;
	const CardLinkProps = {
		target: screen?.lg ? "_blank" : "_self",
		title: data.title,
		link: !data.isExternal ? link : "#",
		rel: data.isExternal ? "nofollow" : null,
	};
	const id = data.id
	const image = data.img
	const youtube = null
	const mode = data.isProject ? "project" : "property"

	const { getImages } = useCardImageGallery({
		id,
		image,
		youtube,
		mode,
	});

	useEffect(() => {
		if (shortCard && !data.isProject && !data.singleImage) {
			const fetchImages = async () => {
				const imagenes = await getImages({ variables: { propertyId: id } });
				const gallery = imagenes?.data?.property?.images;
				if (gallery && gallery.length > 0) {
					const newGallery = gallery.map((g: { id: number; image: string }) => ({
						id: g.id,
						image: g.image,
						tag: null,
					}));
					setGallery(newGallery);
				} else setGallery([]);
			};
			fetchImages();
		}
	}, [shortCard]);

	return (
		<div ref={divRef} className="listingBoxCard">
			<div
				onMouseEnter={onHover}
				onMouseLeave={onHoverEnd}
				ref={parentRef}
				onScrollCapture={onHover}
				className={`listingCard ${isBig ? "isBigCard" : ""} ${isSuperHigh ? "isSuperHighlighted" : ""
					} ${signalsV2 && isSuperHigh && !isInfinite ? "lc-black-v2" : ""} ${isInfinite && !shortCard ? "isInfinite" : ""} ${country_code} ${ids.includes(data.id.toString()) ? "special" : ""} ${shortCard ? "shortCard" : ""
					}`}>

				{isInfinite && !shortCard && (
					<div className="inf-band">
						<span className="inf-mark">
							<TierInfiniteIcon width={29} height={29} />
						</span>
						<b>{INFINITE_TIER_LABEL}</b>
					</div>
				)}

				<div className="lc-cardCover">
					<div className="lc-galleryWrap">
						<CardImageGallery
							id={data.legacy_propID}
							images={shortCard ? gallery : data.images}
							shortCard={shortCard}
							showPagination={data.singleImage ? false : true}
							hasflag={data?.isProject && data?.fair?.active}
							width={shortCard ? 300 : 384}
							height={shortCard ? 225 : 275}
							{...CardLinkProps}
						/>
						{country_code === 'CO' && data.isProject && data.fair && data.fair?.active && (
							<div className="lc-feriaFincaClic">
								<FincaClicLogo />
								<Show when={showFairText}>
									<div>
										<FireIcon /> {data.fair.listing_text}
									</div>
								</Show>
							</div>
						)}
						{signalsV2 && data.tag && data.tag.tag_label ? (
							<span className="lc-etiquetaV2">
								<ProductTagIcon width={13} color="#fff" />
								{data.tag.tag_label}
							</span>
						) : null}
					</div>
					<div className="lc-cardCoverTop">
						<div style={{ flex: 1 }}>
							{!hideTags && data.id !== "" ? (
								showAsciende || showInfinitePill ? (
									// INF-334 — orden de la fila: el pill del tier PRIMERO y el chip del
									// Asciende ÚLTIMO, porque su countdown asoma hacia la foto. El combo mide
									// más que el ancho útil de la card, así que el `flex-wrap` de
									// `.lc-signalsRow` lo baja a dos líneas (pill arriba, chip debajo): es el
									// comportamiento medido y aprobado en INF-333, no hay que forzar una sola.
									<div className="lc-signalsRow">
										<ListingTypeTag id={data.id} data={data} signalsV2 infinitePill={showInfinitePill} />
										{showAsciende && <AsciendeChip turbo={data.turbo_product} />}
									</div>
								) : (
									// INF-334 — rama sin Asciende: donde hay banda del Infinite no va pill, y acá
									// se pide explícito con `hideTier`. En la rama de arriba (con Asciende) el
									// pill del Infinite tampoco sale, pero por otra vía: el 19 no está en
									// `isHighlightedBlack/Gold/Silver` y la rama nueva de `genTagsText` exige
									// `infinitePill`, que sólo pide el shortCard. Espeja la ficha.
									<ListingTypeTag id={data.id} data={data} signalsV2={signalsV2} hideTier={isInfinite} />
								)
							) : null}
						</div>
						<div>
							{!data.isProject ? (
								<Favorite id={data.legacy_propID ?? data.id} type="justIcon" />
							) : null}
						</div>
					</div>

					{data.isProject &&
						data.event.show &&
						data.event.logo !== "" &&
						data.event.tag !== "" &&
						data.event.link !== "" ? (
						<TagEvent event={data.event} />
					) : null}
				</div>

				<div className="lc-dataWrapper">
					{isSuperHigh && !isInfinite && !shortCard && !signalsV2 && (
						<div className="lc-owner-name">{data.owner.name}</div>
					)}
					{signalsV2 && isSuperHigh && !isInfinite && !shortCard && data.isProject && (
						<span className="lc-proyecto-v2">
							<ProjectIcon width={16} height={16} />
							Proyecto
						</span>
					)}
					{isSuperHigh &&
						!shortCard &&
						!data.owner.particular &&
						data?.owner?.logo &&
						country_code !== "ce3" ? (
						<OwnerLogo owner={data.owner} />
					) : null}
					<CardLink
						data={data}
						className="lc-data"
						onCancel={onCancel}
						target={screen?.lg ? "_blank" : "_self"}>
						<div>
							<div
								className="lc-price"
								style={isSuperHigh && !isInfinite && !shortCard && !signalsV2 ? { marginTop: 30 } : {}}>
								{data.currency &&
									data.price &&
									data.price.amount >= 5 &&
									!data.hidePrice ? (
									<>
										<span className="heading heading-4 high">
											{/* MERGE PD: data.isProject ? "Desde" : ""} {data.currency}{" "} ESTO SE AGREGÓ EN UY */}
											{/* MERGE PD: commonExpenses cuando data.operation_type_id !== 4 ESTO SE AGREGÓ EN UY */}

											<PriceTag
												commonExpenses={{
													amount: data.commonExpenses?.amount,
													currency: {
														name: data.commonExpenses_currency,
													},
													hide: data.commonExpenses?.hidePrice,
												}}
												price={
													data.isProject
														? {
															...prices.minPrice,
															hidePrice: false,
														}
														: data.price
												}
												temporalCurrency={data.temporal_currency}
												temporalPrice={data.temporal_price}
												isProject={data.isProject}
												showExpenses={showExpenses}
												operationType={data.operation_type}
											/>

											{country_code === "ce3" && (
												<span className="qty-price">/noche</span>
											)}
										</span>
									</>
								) : (
									<strong>Consultar</strong>
								)}
							</div>

							<strong className="lc-location body body-1 body-bold medium">
								{propertyType ?
									`${translations[propertyType.text.toLocaleLowerCase()] ?
										firstLetterToUppercase(translations[propertyType.text.toLocaleLowerCase()]) :
										propertyType.text
									} en `
									: ""}
								{getLocationLabel(country_name, data.locations, filters)}
							</strong>
						</div>
						<div className="lc-typologyContainer">
							{data.isProject && Array.isArray(data.commercial_units) && data.commercial_units.length > 1 && <p className="lc-location">Unidades desde:</p>}

							<div className="lc-typologyTag">
								{data.isProject
									? projectRoomsOrBedrooms()
									: useRooms
										? rooms()
										: bedrooms()}

								{bathrooms()}

								{m2(propertyType)}

								{showGuests(data.operation_type_id) && (
									<span className="lc-typologyTag__item body body-2 body-regular medium">
										<span>
											<PeopleIcon />
										</span>
										<strong>{data.guests} Huéspedes</strong>
									</span>
								)}
							</div>
						</div>

						<div>
							<h2 className="lc-title body body-2 body-regular medium">
								{capitalize(data.title)}
							</h2>
							{isBig && (
								<p className="lc-description">
									{data.isProject ?
										htmlToPlainText(data.project?.description)
										: htmlToPlainText(data.description)}
								</p>
							)}
						</div>

						{!hideCta ? (
							<div style={{ marginTop: 10 }} className="cta-listing-card">
								<LeadButtons
									id={isUnitProject ? data?.project?.id : data?.id}
									isInListing
									propertyLink={data?.link}
									idealFilters={idealFilters}
									isProject={(isPropertyProject || isUnitProject)}
									projectId={isPropertyProject ? data?.id : isUnitProject ? data?.project?.id : undefined}
									owner={data.owner}
									source="card"
									ctaToShow={{
										contact: true,
										phone: true,
										whatsapp: true
									}}
								/>
							</div>
						) : null}

						{country_code === "ce3" && (
							<div style={{ marginTop: "-10px", maxWidth: "268px" }}>
								<FacilitiesCard
									facilities={data.facilities ?? []}
									dataFormat="idsArray"
								/>
							</div>
						)}
					</CardLink>
				</div>
			</div>

			{showDuplicated && data?.duplicated?.length > 0 && (
				<>
					<div className="duplicated-banner" onClick={toggleDuplicatedDropdown}>
						<span>
							Hay {data.duplicated.length} publicaciones más de esta propiedad. &nbsp;
							<span style={{ fontWeight: "bold" }}>
								{duplicatedDropdown ? "Ver menos" : "Ver todas"}{" "}
							</span>
						</span>
						{!duplicatedDropdown && (
							<>
								<div className="arrow">
									<DownArrow />
								</div>
							</>
						)}
						{duplicatedDropdown && (
							<>
								<div className="arrow up">
									<DownArrow />
								</div>
							</>
						)}
					</div>

					<div
						className={`hidden-holder ${duplicatedDropdown ? "show" : "hide"}`}
						style={
							duplicatedDropdown
								? {
									maxHeight: data.duplicated.length * (screen.lg ? 350 : 650),
									opacity: 1,
								}
								: {}
						}>
						{(alreadyShown || duplicatedDropdown) && (
							<div
								className="duplicated-holder"
								style={{
									display: "flex",
									flexDirection: "column",
									gap: 16,
									marginTop: 16,
								}}>
								{data.duplicated.map((prop, index) => (
									<div key={prop.id}>
										<ListingCard
											data={prop}
											preloadImg={preloadImg}
											showDuplicated={false}
										/>
										{index === data.duplicated.length - 1 && (
											<div
												className="duplicated-banner"
												onClick={toggleDuplicatedDropdown}>
												<span>
													Viste todas las publicaciones de esta propiedad.
													&nbsp;
													<span style={{ fontWeight: "bold" }}>
														{duplicatedDropdown
															? "Ver menos"
															: "Ver todas"}{" "}
													</span>
												</span>
												<div className="arrow up">
													<DownArrow />
												</div>
											</div>
										)}
									</div>
								))}
							</div>
						)}
					</div>
				</>
			)}
		</div>
	);
};

export const CardLink = ({ children, data, className = "", target = "_blank", onCancel, isActive = true }) => {
	let link = data.project && data.project.id ? data.project.link : data.link;
	let isExternal = data.isExternal;

	//@hardcoded - pedido especial de hardcodeo, en algun momento habria que sacar esto y usar directamente data.link y data.isExternal en el render del componente
	if (data.isProject && (data.id == 13755 || data.legacy_propID == 189503363)) {
		link = "https://www.campiglia.com.uy/propiedades_destacadas";
		isExternal = true;
	}
	if (data.id == 15017476) {
		link = "https://landings.infocasas.com.uy/cumbres-jose-ignacio";
		isExternal = true;
	}
	//END @hardcoded - pedido especial de hardcodeo
	const clickHandler = (e: any) => {
		const isOverlayClick =
			e.target.classList.contains("overlay-cta") || e.target.closest(".overlay-cta");

		if (!isActive) {
			e.preventDefault();

			if (typeof onCancel == "function") onCancel();
			return null;
		}
		if (onCancel) onCancel();

		if (isOverlayClick) {
			e.preventDefault();
		} else if (data.isExternal) {
			e.preventDefault();
			let link = data.project && data.project.id ? data.project.link : data.link;

			window.open(
				link,
				"_blank",
				"location=yes,height=670,width=620,scrollbars=yes,status=yes"
			);

		}
	};

	return (
		<a
			className={className}
			target={target}
			title={data.title}
			href={!data.isExternal ? link : "#"}
			rel={isExternal ? "nofollow" : null}
			onClick={clickHandler}>
			{children}
		</a>
	);
};

export const genTagsText = (data, country_code, primaryColor, signals?: { signalsV2?: boolean; hideTier?: boolean; infinitePill?: boolean }) => {
	let tags = [];
	const signalsV2 = !!(signals && signals.signalsV2);

	if (country_code == "ce3" && data.seaDistanceName !== null)
		tags.push({
			name: "seaDistance",
			text: `${data.seaDistanceName} ${data.seaDistanceName != "frente al mar" ? "del mar" : ""
				}`,
			icon: null
		});

	if (data.highlight && !(signals && signals.hideTier)) {
		// INF-334 — el pill del Infinite lo pide sólo quien no dibuja la banda del tier (hoy el
		// shortCard: ver `showInfinitePill` en ListingCard). Donde hay banda, jamás pill, así que
		// sin ese pedido explícito un highlight 19 sigue sin generar pill acá.
		if (signalsV2 && isHighlightedInfinite(data.highlight) && signals && signals.infinitePill) {
			tags.push({ name: "isHighlightedInfinite", text: INFINITE_TIER_LABEL, icon: <TierInfiniteIcon width={18} height={18} /> });
		} else if (isHighlightedBlack(data.highlight)) {
			tags.push(signalsV2
				? { name: "isHighlightedBlack", text: "Destacado Black", icon: <TierStarIcon /> }
				: { name: "isHighlightedBlack", text: "Destacado", icon: <HighlightedIconBlack width={20} height={20} /> });
		} else if (isHighlightedGold(data.highlight)) {
			tags.push(signalsV2
				? { name: "isHighlightedGold", text: "Destacado Gold", icon: <TierStarIcon /> }
				: { name: "isHighlightedGold", text: "Destacado", icon: <HighlightedIconGold width={20} height={20} /> });
		} else if (isHighlightedSilver(data.highlight)) {
			tags.push(signalsV2
				? { name: "isHighlightedSilver", text: "Destacado Silver", icon: <TierStarIcon /> }
				: { name: "isHighlightedSilver", text: "Destacado", icon: <HighlightedIconSilver width={20} height={20} /> });
		}
	}

	// Señales v2: la etiqueta se dibuja sobre la foto (ListingCard), no en esta tira
	if (data.tag && data.tag.tag_type && !signalsV2) {
		tags.push({ name: `tag-${data.tag.tag_type}`, text: data.tag.tag_label, icon: <ProductTagIcon width={16} color={primaryColor} /> });
	}

	if (data.isProject) tags.push({ name: "isProject", text: null, icon: <ProjectIcon width={18} height={18} /> });
	if (data.isExternal) tags.push({ name: "isExternal", text: "Ficha externa", icon: null });
	if (data.tour3d) tags.push({ name: "tour3d", text: null, icon: <VirtualTourIcon width={25} height={25} /> });

	return tags;
};
